var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ap-sidebar-container" }, [
    _c("div", { staticClass: "ap-sidebar-menu-container" }, [
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "adminProducts" },
          on: {
            click: function($event) {
              return _vm.openPage("adminProducts")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGAdminProducts", { staticClass: "ap-sidebar-svg" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Продукция\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "AdminCategories" },
          on: {
            click: function($event) {
              return _vm.openPage("AdminCategories")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGAdminCategories", { staticClass: "ap-sidebar-svg" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Категории\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "adminProjects" },
          on: {
            click: function($event) {
              return _vm.openPage("adminProjects")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGAdminProjects", { staticClass: "ap-sidebar-svg" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Проекты\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "adminIncoming" },
          on: {
            click: function($event) {
              return _vm.openPage("adminIncoming")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGMail", { staticClass: "ap-sidebar-svg-fa" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Заявки\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "adminCustomers" },
          on: {
            click: function($event) {
              return _vm.openPage("adminCustomers")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGAdminCustomers", { staticClass: "ap-sidebar-svg" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Заказчики\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "adminUsers" },
          on: {
            click: function($event) {
              return _vm.openPage("adminUsers")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGAdminUsers", { staticClass: "ap-sidebar-svg" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Пользователи\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "adminOrganizations" },
          on: {
            click: function($event) {
              return _vm.openPage("adminOrganizations")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGAdminOrganizations", { staticClass: "ap-sidebar-svg" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Организации\n            ")
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "ap-sidebar-menu-element",
          class: { "active-page": _vm.activePage === "adminConfig" },
          on: {
            click: function($event) {
              return _vm.openPage("adminConfig")
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "ap-sidebar-menu-element-icon" },
            [_c("SVGWrench", { staticClass: "ap-sidebar-svg" })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
            _vm._v("\n                Конфигурация\n            ")
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "ap-sidebar-menu-configurator-btn",
        on: {
          click: function($event) {
            return _vm.openPage("projects")
          }
        }
      },
      [
        _c(
          "div",
          { staticClass: "ap-sidebar-menu-element-icon" },
          [_c("SVGArrowLeft")],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "ap-sidebar-menu-element-name" }, [
          _vm._v("\n            К конфигуратору\n        ")
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }